import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { Modal } from 'react-bootstrap';

// Redux
import { connect } from 'react-redux';
import { closeWishListModal } from '../../actions/WishList/modalActions';

// Components
import WishListModalForm from '../WishListModalForm';
import Loader from '../Loader';
import CreateWishList from './CreateWishList';

// Translation
import { FormattedMessage, injectIntl } from 'react-intl';

// Locale
import messages from '../../locale/jsonMessages';

// GraphQL
import { flowRight as compose } from 'lodash';
import { getWishListGroup } from '../../lib/graphql';
import { withQuery } from '../../hoc/withGraphql';

import cs from '../../components/commonStyle.css';
import s from './WishListModal.css';

const WishListModal = ({
  closeWishListModal,
  wishListModal,
  data: { loading, getAllWishListGroup },
  profileId,
  listId
}) => {
  const [wishListModalStatus, setWishListModalStatus] = useState(false);

  useEffect(() => {
    document.documentElement.classList.add('scrollHidden');
    return () => {
      document.documentElement.classList.remove('scrollHidden');
    };
  }, []);

  useEffect(() => {
    setWishListModalStatus(wishListModal === true);
  }, [wishListModal]);

  const wishListGroups = useMemo(() => {
    const groups = [];
    if (getAllWishListGroup && getAllWishListGroup.count > 0) {
      getAllWishListGroup.wishListGroupData.forEach((option) => {
        if (option.wishListIds.includes(listId)) {
          groups.push(option.id);
        }
      });
    }
    return groups;
  }, [getAllWishListGroup, listId]);

  const initialValues = {
    listId,
    wishListGroups
  };

  return (
    <Modal
      show={wishListModalStatus}
      animation={false}
      onHide={closeWishListModal}
      dialogClassName='commonModalContainer whistListModalContainer'
    >
      <Modal.Header closeButton className='commonModalHeader'>
        <Modal.Title className='commonModalTitle'><FormattedMessage {...messages.wishLists} /></Modal.Title>
      </Modal.Header>
      <Modal.Body bsClass='commonModalBody'>
        <CreateWishList initialValues={initialValues} />
        <hr className={cx(cs.listingHorizoltalLine, cs.spaceTop3, cs.spaceBottom3)} />
        {loading ? <Loader type="text" /> : <WishListModalForm data={{ loading, getAllWishListGroup }} initialValues={initialValues} />}
      </Modal.Body>
    </Modal>
  );
};

WishListModal.propTypes = {
  closeWishListModal: PropTypes.any,
  wishListModal: PropTypes.bool,
  data: PropTypes.shape({
    loading: PropTypes.bool,
    getAllWishListGroup: PropTypes.any
  }),
  profileId: PropTypes.number,
  listId: PropTypes.number
};

WishListModal.defaultProps = {
  data: {
    loading: true
  }
};

const mapState = state => ({
  wishListModal: state.modalStatus.wishListModalOpen,
  profileId: state.account.data.profileId,
  listId: state.modalStatus.listId
});

const mapDispatch = {
  closeWishListModal
};

export default compose(
  injectIntl,
  withStyles(cs, s),
  connect(mapState, mapDispatch),
  withQuery(getWishListGroup, {
    options: (props) => ({
      variables: {
        profileId: props.profileId
      },
      fetchPolicy: 'network-only',
      ssr: false
    })
  })
)(WishListModal);
